import React from "react";

const Loader = () => {
    return (
        <div className="loader py-5">
            <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )
}

export default Loader
